import {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'

const equipRouter: RouteConfig = {
  path: '/resultsAnalyse',
  redirect: 'noredirect',
  name: 'resultsAnalyse',
  component: Layout,
  children: [
    {
      path: 'resultsAnalyse',
      component: () => import('@/views/resultsAnalyse/index.vue'),
      name: 'resultsAnalyse',
      meta: {
        title: '训练考核成绩管理',
        icon: 'resource',
        requireAuth: true,
      }
    },
  ]

}

export default equipRouter
